import { FormRequestActions } from "../actions/formRequestActions";
import { PollActions } from "../actions/pollActions";
import { SchematicAPI } from "../actions/schematicAPI";
import { ServerAPI } from "../actions/serverAPI";
import Constants from "../constants/constants";
import { dispatcher } from "../dispatcher/dispatcher";
import { storeUtils } from "../stores/util";
import { formConversion } from "../util/formConversion";
const { ActionTypes } = Constants;

var SubmitActions = Constants.restrictionActions;

var STATUS = Constants.RestrictionStatuses;
var issuedListXhr;

function checkOutageState(isTriggerReq) {
  var trigReq = { isTriggerReq: isTriggerReq };
  $.ajax({
    type: "POST",
    contentType: "application/json",
    url: storeUtils.URL_ROOT + "outage/currentState",
    data: JSON.stringify(trigReq),
    headers: {
      Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
    },
    dataType: "json",
    success: function (data) {
      console.log("Done checking outage state", data);
      if (data) {
        var outageState = data;
        dispatcher.dispatch({
          type: ActionTypes.OUTAGE_FROM_SERVER,
          outageState: outageState,
        });
      }
    },
    error: function (data, status, error) {
      //this means the polling service threw an error
      console.error(
        "Error  getting outage state from server",
        data,
        status,
        error
      );
    },
  });
}

function checkOutageStateAndRestartTimer() {
  checkOutageState(true);
  setTimeout(
    checkOutageStateAndRestartTimer,
    Constants.MaxValues.OUTAGE_RETRY_WAIT_PERIOD
  );
}

export const ServerActions = {
  startOutageStateCheck: function () {
    checkOutageStateAndRestartTimer();
  },

  setOutageDetail: function () {
    checkOutageState(false);
  },

  // Drop Alert API call for voided modal close
  dropAlert: function({ syncId, restrictionNumber, dsId, subdivision }) {
    var payload = {
       "syncId" : syncId,
      "restrictionNumber" : restrictionNumber,
      "dispatcherId" : dsId,
      "subdivision" : subdivision,
    };

    $.ajax({
      type: "POST",
      contentType: "application/json",
      url: storeUtils.URL_ROOT + "form/confirmVoid",
      data: JSON.stringify(payload),
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      dataType: "json",
      success: function (data) {
        console.log("Done dropping void", data);
      },
      error: function (data, status, error) {
        //this means the polling service threw an error
        console.error(
          "Error dropping void on server",
          data,
          status,
          error
        );
      },
    });
  },
  pollServer: function (id) {
    dispatcher.dispatch({
      type: ActionTypes.START_POLL,
    });

    console.log(ActionTypes.START_POLL, "ids:[", id, "]");

    //id = { id: id };
    $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "poll",
      data: JSON.stringify(id),
      dataType: "json",
      success: function (data, status, xhr) {
        if (data.success) {
          //this means we succesfully found a pending Action that did NOT have status "TSS"
          console.log(
            ActionTypes.STOP_POLL,
            "TSS response found, Data Returned:",
            data,
            status,
            xhr
          );
          var requestValidationResult = data.data;
          if (requestValidationResult.success) {
            //this means TSS returned a "000" and action succeeded
            console.log("TSS response is SUCCESS!!!");
            PollActions.mfSuccessReturnedFromPoll(requestValidationResult.data);
          } else {
            //this means TSS returned some code other than "000"
            //some error was returned from TSS so we need to redisplay this to the user
            console.log("TSS response is an error:", requestValidationResult);
            PollActions.mfErrorReturnedFromPoll(requestValidationResult);
          }
        } else {
          //this means TSS hasn't responded yet
          console.log(
            ActionTypes.STOP_POLL,
            "No response from TSS yet, return message: [" +
            data.errors[0].message +
            "]"
          );
          PollActions.mfNoResponseYetOnPoll();
        }
        dispatcher.dispatch({
          type: ActionTypes.STOP_POLL,
        });
      },
      error: function (data, status, error) {
        //this means the polling service threw an error
        console.log(
          ActionTypes.KILL_POLLING_DUE_TO_ERROR,
          "Failed Poll, Data Returned:",
          data,
          status,
          error
        );
        dispatcher.dispatch({
          type: ActionTypes.KILL_POLLING_DUE_TO_ERROR,
        });
      },
    });
  },
  openRequestOrRestriction: function (
    id,
    waitForSubLoad,
    calculateGuids = true
  ) {
    dispatcher.dispatch({
      type: ActionTypes.OPENING_RESTRICTION,
    });

    var timeout = 0;
    if (waitForSubLoad) {
      timeout = 1000;
    }
    setTimeout(function () {
      $.ajax({
        url: storeUtils.URL_ROOT + "form/showRequest/" + id,
        type: "GET",
        contentType: "application/json",
        headers: {
          Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
        },
        success: function (data) {
          if (data.success) {
            var form = formConversion.getNewClientFormat(data.data);
            var message;

            if (
              data.data.restrictionDetail.type === Constants.RestrictionTypes.C
            ) {
              calculateGuids = false;
            }

            if (data.data.status === "restriction") {
              message =
                "An error occurred opening restriction " +
                data.data.restrictionDetail.controlNumber;
            } else {
              message =
                "An error occurred opening request GR" + data.data.syncId;
            }

            var formConversionError = { message: message, type: "error" };
            if (form) {
              //If the form is not null the conversion was successful so null the error
              formConversionError = null;
              if (form.isPushedFromTss) {
                calculateGuids = true;
              }
            }

            if (form && calculateGuids && !form.isOverrideItem) {
              //Don't try to calculate tracks for an override item
              FormRequestActions.calculateTracks(form, true);
            }

            if (
              data.data.restrictionDetail.type === Constants.RestrictionTypes.B
            ) {
              if (data.data.status === Constants.RestrictionStatuses.ISSUED) {
                dispatcher.dispatch({
                  type: ActionTypes.OPEN_FORM_B_RESTRICTION,
                  form: form,
                  errorMessage: formConversionError,
                });
              } else {
                dispatcher.dispatch({
                  type: ActionTypes.OPEN_FORM_B_REQUEST,
                  form: form,
                  errorMessage: formConversionError,
                });
              }
            } else if (
              data.data.restrictionDetail.type === Constants.RestrictionTypes.A
            ) {
              if (data.data.status === Constants.RestrictionStatuses.ISSUED) {
                dispatcher.dispatch({
                  type: ActionTypes.OPEN_FORM_A_RESTRICTION,
                  form: form,
                  errorMessage: formConversionError,
                });
              } else {
                dispatcher.dispatch({
                  type: ActionTypes.OPEN_FORM_A_REQUEST,
                  form: form,
                  errorMessage: formConversionError,
                });
              }
            } else if (
              data.data.restrictionDetail.type === Constants.RestrictionTypes.C
            ) {
              if (data.data.status === Constants.RestrictionStatuses.ISSUED) {
                dispatcher.dispatch({
                  type: ActionTypes.OPEN_FORM_C_RESTRICTION,
                  form: form,
                  errorMessage: formConversionError,
                });
              }
            } else if (
              data.data.restrictionDetail.type ===
              Constants.RestrictionTypes.TCM
            ) {
              if (data.data.status === Constants.RestrictionStatuses.ISSUED) {
                dispatcher.dispatch({
                  type: ActionTypes.OPEN_TCM_RESTRICTION,
                  form: form,
                  errorMessage: formConversionError,
                });
              }
            }
          } else {
            console.log("Failed to load detail from server");
            dispatcher.dispatch({
              type: ActionTypes.SERVER_ACTION_FAILED,
              message: data.errors.map(function (er) {
                return {
                  field: er.field,
                  message: er.message,
                  type: er.severity,
                };
              }),
            });
          }
        },
        error: function () {
          dispatcher.dispatch({
            type: ActionTypes.SERVER_ACTION_FAILED,
            message: [
              {
                field: "formBform",
                message: "A problem occurred while loading details",
                type: "error",
              },
            ],
          });
        },
      });
    }, timeout);
  },

  openRequestToModify: function (id, waitForSubLoad, calculateGuids = true) {
    dispatcher.dispatch({
      type: ActionTypes.OPENING_RESTRICTION,
    });

    var timeout = 0;
    if (waitForSubLoad) {
      timeout = 1000;
    }
    setTimeout(function () {
      $.ajax({
        url: storeUtils.URL_ROOT + "form/showRequestToModify/" + id,
        type: "GET",
        contentType: "application/json",
        headers: {
          Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
        },
        success: function (data) {
          if (data.success) {
            var form = formConversion.getNewClientFormat(data.data.request);
            let activeForm = formConversion.getNewClientFormat(
              data.data.restriction
            );
            var message;

            message = "An error occurred opening request GR" + data.data.syncId;

            var formConversionError = { message: message, type: "error" };
            if (form) {
              //If the form is not null the conversion was successful so null the error
              formConversionError = null;
              if (form.isPushedFromTss) {
                calculateGuids = true;
              }
            }

            if (form && calculateGuids && !form.isOverrideItem) {
              //Don't try to calculate tracks for an override item
              FormRequestActions.calculateTracks(form, true);
            }

            if (form.type === Constants.RestrictionTypes.A) {
              dispatcher.dispatch({
                type: ActionTypes.OPEN_FORM_A_REQUEST,
                form: form,
                activeForm: activeForm,
                errorMessage: formConversionError,
              });
            }
          } else {
            console.log("Failed to load detail from server");
            dispatcher.dispatch({
              type: ActionTypes.SERVER_ACTION_FAILED,
              message: data.errors.map(function (er) {
                return {
                  field: er.field,
                  message: er.message,
                  type: er.severity,
                };
              }),
            });
          }
        },
        error: function () {
          dispatcher.dispatch({
            type: ActionTypes.SERVER_ACTION_FAILED,
            message: [
              {
                field: "formBform",
                message: "A problem occurred while loading details",
                type: "error",
              },
            ],
          });
        },
      });
    }, timeout);
  },

  openRestrictionByControlNumberSubdivision: function (
    controlNumber,
    subdivision
  ) {
    dispatcher.dispatch({
      type: ActionTypes.OPENING_RESTRICTION,
    });

    let calculateGuids = true;

    // var timeout = 0;
    // if (waitForSubLoad) {
    //     timeout = 1000;
    // }
    setTimeout(function () {
      $.ajax({
        type: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
        },
        url:
          storeUtils.URL_ROOT +
          "form/showRestrictionByControlNumberSubdivision",
        dataType: "json",
        data: JSON.stringify({
          controlNumber: controlNumber,
          subdivision: subdivision,
        }),
        success: function (data) {
          if (data.success) {
            var form = formConversion.getNewClientFormat(data.data);
            var message;

            if (
              data.data.restrictionDetail.type === Constants.RestrictionTypes.C
            ) {
              calculateGuids = false;
            }

            if (data.data.status === "restriction") {
              message =
                "An error occurred opening restriction " +
                data.data.restrictionDetail.controlNumber;
            } else {
              message =
                "An error occurred opening request GR" + data.data.syncId;
            }

            var formConversionError = { message: message, type: "error" };
            if (form) {
              //If the form is not null the conversion was successful so null the error
              formConversionError = null;
              if (form.isPushedFromTss) {
                calculateGuids = true;
              }
            }

            if (form && calculateGuids && !form.isOverrideItem) {
              //Don't try to calculate tracks for an override item
              FormRequestActions.calculateTracks(form, true);
            }

            if (
              data.data.restrictionDetail.type === Constants.RestrictionTypes.B
            ) {
              if (data.data.status === Constants.RestrictionStatuses.ISSUED) {
                dispatcher.dispatch({
                  type: ActionTypes.OPEN_FORM_B_RESTRICTION,
                  form: form,
                  errorMessage: formConversionError,
                });
              } else {
                dispatcher.dispatch({
                  type: ActionTypes.OPEN_FORM_B_REQUEST,
                  form: form,
                  errorMessage: formConversionError,
                });
              }
            } else if (
              data.data.restrictionDetail.type === Constants.RestrictionTypes.A
            ) {
              if (data.data.status === Constants.RestrictionStatuses.ISSUED) {
                dispatcher.dispatch({
                  type: ActionTypes.OPEN_FORM_A_RESTRICTION,
                  form: form,
                  errorMessage: formConversionError,
                });
              } else {
                dispatcher.dispatch({
                  type: ActionTypes.OPEN_FORM_A_REQUEST,
                  form: form,
                  errorMessage: formConversionError,
                });
              }
            } else if (
              data.data.restrictionDetail.type === Constants.RestrictionTypes.C
            ) {
              if (data.data.status === Constants.RestrictionStatuses.ISSUED) {
                dispatcher.dispatch({
                  type: ActionTypes.OPEN_FORM_C_RESTRICTION,
                  form: form,
                  errorMessage: formConversionError,
                });
              }
            } else if (
              data.data.restrictionDetail.type ===
              Constants.RestrictionTypes.TCM
            ) {
              if (data.data.status === Constants.RestrictionStatuses.ISSUED) {
                dispatcher.dispatch({
                  type: ActionTypes.OPEN_TCM_RESTRICTION,
                  form: form,
                  errorMessage: formConversionError,
                });
              }
            }
          } else {
            console.log("Failed to load detail from server");
            dispatcher.dispatch({
              type: ActionTypes.SERVER_ACTION_FAILED,
              message: data.errors.map(function (er) {
                return {
                  field: er.field,
                  message: er.message,
                  type: er.severity,
                };
              }),
            });
          }
        },
        error: function () {
          dispatcher.dispatch({
            type: ActionTypes.SERVER_ACTION_FAILED,
            message: [
              {
                field: "formBform",
                message: "A problem occurred while loading details",
                type: "error",
              },
            ],
          });
        },
      });
    }, 1000);
  },

  openRequestBySyncIdSubdivision: function (syncId, subdivision,voided,dsJobId) {
    dispatcher.dispatch({
      type: ActionTypes.OPENING_RESTRICTION,
    });

    let calculateGuids = true;

    // var timeout = 0;
    // if (waitForSubLoad) {
    //     timeout = 1000;
    // }
    setTimeout(function () {
      $.ajax({
        type: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
        },
        url: storeUtils.URL_ROOT + "form/showRequestBySyncIdSubdivision",
        dataType: "json",
        data: JSON.stringify({ syncId: syncId, subdivision: subdivision , voided: voided ,dispatcherId: dsJobId}),
        success: function (data) {
          if (data.success) {
            var form = formConversion.getNewClientFormat(data.data);
            var message;

            if (
              data.data.restrictionDetail.type === Constants.RestrictionTypes.C
            ) {
              calculateGuids = false;
            }

            if (data.data.status === "restriction") {
              message =
                "An error occurred opening restriction " +
                data.data.restrictionDetail.controlNumber;
            } else {
              message =
                "An error occurred opening request GR" + data.data.syncId;
            }

            var formConversionError = { message: message, type: "error" };
            if (form) {
              //If the form is not null the conversion was successful so null the error
              formConversionError = null;
              if (form.isPushedFromTss) {
                calculateGuids = true;
              }
            }

            if (form && calculateGuids && !form.isOverrideItem) {
              //Don't try to calculate tracks for an override item
              FormRequestActions.calculateTracks(form, true);
            }

            if (
              data.data.restrictionDetail.type === Constants.RestrictionTypes.B
            ) {
              if (data.data.status === Constants.RestrictionStatuses.ISSUED) {
                dispatcher.dispatch({
                  type: ActionTypes.OPEN_FORM_B_RESTRICTION,
                  form: form,
                  errorMessage: formConversionError,
                });
              } else {
                dispatcher.dispatch({
                  type: ActionTypes.OPEN_FORM_B_REQUEST,
                  form: form,
                  errorMessage: formConversionError,
                });
              }
            } else if (
              data.data.restrictionDetail.type === Constants.RestrictionTypes.A
            ) {
              if (data.data.status === Constants.RestrictionStatuses.ISSUED && data.data.pendingAction !== "M") {
                dispatcher.dispatch({
                  type: ActionTypes.OPEN_FORM_A_RESTRICTION,
                  form: form,
                  errorMessage: formConversionError,
                });
              } else {
                dispatcher.dispatch({
                  type: ActionTypes.OPEN_FORM_A_REQUEST,
                  form: form,
                  openVoidedDialog: (data.data.status === Constants.RestrictionStatuses.VOIDED || data.data.status === "restriction"),
                  errorMessage: formConversionError,
                });
              }
            } else if (
              data.data.restrictionDetail.type === Constants.RestrictionTypes.C
            ) {
              if (data.data.status === Constants.RestrictionStatuses.ISSUED) {
                dispatcher.dispatch({
                  type: ActionTypes.OPEN_FORM_C_RESTRICTION,
                  form: form,
                  errorMessage: formConversionError,
                });
              }
            } else if (
              data.data.restrictionDetail.type ===
              Constants.RestrictionTypes.TCM
            ) {
              if (data.data.status === Constants.RestrictionStatuses.ISSUED) {
                dispatcher.dispatch({
                  type: ActionTypes.OPEN_TCM_RESTRICTION,
                  form: form,
                  errorMessage: formConversionError,
                });
              }
            }
          } else {
            console.log("Failed to load detail from server");
            dispatcher.dispatch({
              type: ActionTypes.SERVER_ACTION_FAILED,
              message: data.errors.map(function (er) {
                return {
                  field: er.field,
                  message: er.message,
                  type: er.severity,
                };
              }),
            });
          }
        },
        error: function () {
          dispatcher.dispatch({
            type: ActionTypes.SERVER_ACTION_FAILED,
            message: [
              {
                field: "formBform",
                message: "A problem occurred while loading details",
                type: "error",
              },
            ],
          });
        },
      });
    }, 1000);
  },

  openRequestToModifyBySyncIdSubdivision: function (syncId, subdivision) {
    dispatcher.dispatch({
      type: ActionTypes.OPENING_RESTRICTION,
    });

    let calculateGuids = true;

    // var timeout = 0;
    // if (waitForSubLoad) {
    //     timeout = 1000;
    // }
    setTimeout(function () {
      $.ajax({
        type: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
        },
        url:
          storeUtils.URL_ROOT + "form/showRequestToModifyBySyncIdSubdivision",
        dataType: "json",
        data: JSON.stringify({
          syncId: syncId,
          subdivision: subdivision,
          type: "modify",
        }),
        success: function (data) {
          if (data.success) {
            var form = formConversion.getNewClientFormat(data.data.request);
            let activeForm = formConversion.getNewClientFormat(
              data.data.restriction
            );
            var message;

            message = "An error occurred opening request GR" + form.syncId;

            var formConversionError = { message: message, type: "error" };
            if (form) {
              //If the form is not null the conversion was successful so null the error
              formConversionError = null;
              if (form.isPushedFromTss) {
                calculateGuids = true;
              }
            }

            if (form && calculateGuids && !form.isOverrideItem) {
              //Don't try to calculate tracks for an override item
              FormRequestActions.calculateTracks(form, true);
            }

            if (form.type === Constants.RestrictionTypes.A) {
              dispatcher.dispatch({
                type: ActionTypes.OPEN_FORM_A_REQUEST,
                form: form,
                activeForm: activeForm,
                errorMessage: formConversionError,
              });
            }
          } else {
            console.log("Failed to load detail from server");
            dispatcher.dispatch({
              type: ActionTypes.SERVER_ACTION_FAILED,
              message: data.errors.map(function (er) {
                return {
                  field: er.field,
                  message: er.message,
                  type: er.severity,
                };
              }),
            });
          }
        },
        error: function () {
          dispatcher.dispatch({
            type: ActionTypes.SERVER_ACTION_FAILED,
            message: [
              {
                field: "formBform",
                message: "A problem occurred while loading details",
                type: "error",
              },
            ],
          });
        },
      });
    }, 1000);
  },

  openRequestforApproval: function (id, waitForSubLoad) {
    dispatcher.dispatch({
      type: ActionTypes.OPENING_RESTRICTION,
    });

    var timeout = 0;
    if (waitForSubLoad) {
      timeout = 1000;
    }
    setTimeout(function () {
      $.ajax({
        url: storeUtils.URL_ROOT + "form/showRequest/" + id,
        type: "GET",
        contentType: "application/json",
        headers: {
          Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
        },
        success: function (data) {
          if (data.success) {
            var form = formConversion.getClientFormat(data.data);
            var message;

            if (data.data.status == "restriction") {
              message =
                "An error occurred opening restriction " +
                data.data.restrictionDetail.controlNumber;
            } else {
              message =
                "An error occurred opening request GR" + data.data.syncId;
            }

            var formConversionError = { message: message, type: "error" };
            if (form) {
              //If the form is not null the conversion was successful so null the error
              formConversionError = null;
            }

            if (
              data.data.restrictionDetail.type === Constants.RestrictionTypes.B
            ) {
              if (data.data.status === Constants.RestrictionStatuses.ISSUED) {
                dispatcher.dispatch({
                  type: ActionTypes.OPEN_FORM_B_RESTRICTION,
                  form: form,
                  errorMessage: formConversionError,
                });
              } else {
                dispatcher.dispatch({
                  type: ActionTypes.OPEN_FORM_B_REQUEST,
                  form: form,
                  errorMessage: formConversionError,
                });
              }
            } else if (
              data.data.restrictionDetail.type === Constants.RestrictionTypes.A
            ) {
              if (data.data.status === Constants.RestrictionStatuses.ISSUED) {
                dispatcher.dispatch({
                  type: ActionTypes.OPEN_FORM_A_RESTRICTION,
                  form: form,
                  errorMessage: formConversionError,
                });
              } else {
                dispatcher.dispatch({
                  type: ActionTypes.OPEN_FORM_A_REQUEST,
                  form: form,
                  errorMessage: formConversionError,
                });
              }
            }
          } else {
            console.log("Failed to load detail from server");
            dispatcher.dispatch({
              type: ActionTypes.SERVER_ACTION_FAILED,
              message: data.errors.map(function (er) {
                return {
                  field: er.field,
                  message: er.message,
                  type: er.severity,
                };
              }),
            });
          }
        },
        error: function () {
          dispatcher.dispatch({
            type: ActionTypes.SERVER_ACTION_FAILED,
            message: [
              {
                field: "formBform",
                message: "A problem occurred while loading details",
                type: "error",
              },
            ],
          });
        },
      });
    }, timeout);
  },

  openRequestOrRestrictionPromise: function (id) {
    return $.ajax({
      url: storeUtils.URL_ROOT + "form/showRequest/" + id,
      type: "GET",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
    });
  },

  openRequestOrRestrictionForRecalculate: function (
    restrictionList,
    subdivision
  ) {
    var selectedSchematic = $("#gisSelect").val();

    var trackCalculationData = {
      restrictionList: restrictionList,
      environment: selectedSchematic,
      subdivision: subdivision,
    };
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "sls/runCompareCalculateGuids",
      dataType: "json",
      data: JSON.stringify(trackCalculationData),
    });
  },

  /**
   *
   * @param submitDetails: {id, shouldClearForm, printLata, Constants.restrictionActions, requestToSubmit, transferredDsId}
   */
  submitItemToServer: function (submitDetails) {
    //call to this function should look like:
    //ServerActions.submitItemToServer({
    //	action:ActionTypes.restrictionActions.ISSUE_RESTRICTION,
    //	id:234,
    //	printLata:"",
    //	requestToSubmit:"formB",
    //	transferredDsId:"DS234",
    //  rejectReason:"some reason"
    //});

    /*
     * put site into PENDING status (locked out, cannot do any action)
     * Send item(s) to Server
     * 	http 200:
     * 		on success:
     * 			add item(s) to polling list
     * 		on error:
     *			redisplay submission with errors from server
     *			take site  out of PENDING status
     * 	http 500/404:
     * 		redisplay submission with errors from server
     * 		take site  out of PENDING status
     *
     *
     * Poller:
     * 	poll for every item in list
     *		if every item is successful:
     *			Display messages for each item
     *			remove each item from the polling list
     *			take site out of PENDING status
     *		if > 1 item is unsuccessful:
     *			for each item returned:
     *				if successful:
     *					handle only when batching is implemented, for now, only one item will exist at a time
     *				if unsuccesful:
     *					redisplay submission with errors from server
     *					take site out of PENDING status
     * */

    if (submitDetails && submitDetails.action) {
      dispatcher.dispatch({
        type: ActionTypes.SUBMITTING_TO_SERVER,
      });

      var data = {}; //the data to be submitted to the server

      if (!submitDetails.requestToSubmit) {
        console.error(
          "tried to {action} but no request was submitted!".replace(
            "{action}",
            submitDetails.action
          )
        );
      } else {
        data.restriction = submitDetails.requestToSubmit;
      }

      switch (submitDetails.action) {
        case SubmitActions.SUBMIT_REQUEST:
        case SubmitActions.UPDATE_REQUEST:
        case SubmitActions.SLODT_RESTRICTION:
        case SubmitActions.ISSUE_RESTRICTION:
        case SubmitActions.APPROVE_REQUEST:
        case SubmitActions.MODIFY_RESTRICTION:
        case SubmitActions.APPROVE_REQUEST_TO_MODIFY:
        case SubmitActions.UPDATE_RESTRICTION:
        case SubmitActions.MODIFY_FORM_C_RESTRICTION:
        case SubmitActions.APPROVE_VERBAL_FORMA_RESTRICTION:
        case SubmitActions.FORMCDT_RESTRICTION:
        case SubmitActions.TCMDT_RESTRICTION:
          if (!submitDetails.printLata) {
            console.error(
              "tried to {action} but no printLata was submitted!".replace(
                "{action}",
                submitDetails.action
              )
            );
          } else {
            data.printLata = submitDetails.printLata;
          }
          break;

        case SubmitActions.TRANSFER_REQUEST:
          if (!submitDetails.transferredDsId) {
            console.error(
              "tried to {action} but no dispatcher transfer ID was submitted!".replace(
                "{action}",
                submitDetails.action
              )
            );
          } else {
            data.transferredDsId = submitDetails.transferredDsId;
          }
          if (!submitDetails.printLata) {
            console.error(
              "tried to {action} but no printLata was submitted!".replace(
                "{action}",
                submitDetails.action
              )
            );
          } else {
            data.printLata = submitDetails.printLata;
          }

          if (!submitDetails.id) {
            console.error(
              "tried to {action} but no request ID was submitted!".replace(
                "{action}",
                submitDetails.action
              )
            );
          } else {
            data.id = submitDetails.id;
          }

          if (submitDetails.dsId) {
            data.dsId = submitDetails.dsId;
          }
          break;

        case SubmitActions.REJECT_REQUEST:
          if (!submitDetails.rejectReason) {
            console.error(
              "tried to {action} but no rejection reason was submitted!".replace(
                "{action}",
                submitDetails.action
              )
            );
          } else {
            data.reason = submitDetails.rejectReason;
          }
          if (!submitDetails.printLata) {
            console.error(
              "tried to {action} but no printLata was submitted!".replace(
                "{action}",
                submitDetails.action
              )
            );
          } else {
            data.printLata = submitDetails.printLata;
          }

          if (!submitDetails.id) {
            console.error(
              "tried to {action} but no request ID was submitted!".replace(
                "{action}",
                submitDetails.action
              )
            );
          } else {
            data.id = submitDetails.id;
          }
          break;

        case SubmitActions.VOID_RESTRICTION:
        case SubmitActions.DELETE_REQUEST:
          if (!submitDetails.printLata) {
            console.error(
              "tried to {action} but no printLata was submitted!".replace(
                "{action}",
                submitDetails.action
              )
            );
          } else {
            data.printLata = submitDetails.printLata;
          }

          if (!submitDetails.id) {
            console.error(
              "tried to {action} but no request ID was submitted!".replace(
                "{action}",
                submitDetails.action
              )
            );
          } else {
            data.id = submitDetails.id;
          }
          break;

        default:
          console.error(
            "Tried to submit item to server with unknown action type, action: ",
            submitDetails.action
          );
      }

      //finally, we have our data object, submit to the server, in theory we never got here if we're missing some
      $.ajax({
        type: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
        },
        url: storeUtils.URL_ROOT + "form/" + submitDetails.action,
        dataType: "json",
        data: JSON.stringify(data),
        success: function (data, status, xhr) {
          console.log("successful transport to server", data, status, xhr);
          if (data.success) {
            dispatcher.dispatch({
              type: ActionTypes.SUBMIT_TO_SERVER_SUCCESSFUL,
              submitAction: submitDetails.action,
              request: data.data,
            });

            //Since they have submitted, make sure that default tracks are turned off
            dispatcher.dispatch({
              type: ActionTypes.SHOW_DEFAULT_TRACKS_VALUE_CHANGED,
              value: false,
            });

            //we know now that the item has been submitted to the MF queue but nothing else
            //setup the poller, keep the UI locked
          } else {
            //some error occurred on the GRIT server, redisplay the item to the user with the error
            var messages = [];
            for (var i = 0; i < data.errors.length; i++) {
              messages.push({
                field: "submissionError",
                message: data.errors[i].message,
                type: "error",
              });
            }

            console.error(
              "An error occurred on the server, need to verify the GRIT sync ID is being stored in this case, here is the data:",
              data
            );
            dispatcher.dispatch({
              type: ActionTypes.SUBMIT_TO_SERVER_FAILED,
              submitAction: submitDetails.action,
              data: data.data,
              message: messages,
            });
          }
        },
        error: function (data, status, error) {
          console.log(error, status, data);
          //we had an http transport error, redisplay the item to the user and give an error
          dispatcher.dispatch({
            type: ActionTypes.SUBMIT_TO_SERVER_404_500,
            submitAction: submitDetails.action,
            data: data,
            message: [
              {
                field: "transportFailed",
                message:
                  "An unknown error occurred on the server while trying to process your submission. Please retry.",
                type: "error",
              },
            ],
          });
        },
      });
    } else {
      console.error(
        "Tried to submit item to server but no action was given, submit details: ",
        submitDetails
      );
    }
  },

  getReasonList: function (formType) {
    var obj = { formType: formType };
    $.ajax({
      type: "POST",
      contentType: "application/json",
      url: storeUtils.URL_ROOT + "requestList/reasonCodes",
      data: JSON.stringify(obj),
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      dataType: "json",
      success: function (data) {
        dispatcher.dispatch({
          type: ActionTypes.REASON_CODES_LOADED,
          codes: data.data,
          formType: formType,
        });
      },
    });
  },

  getOutageList: function () {
    dispatcher.dispatch({
      type: ActionTypes.LOAD_OUTAGE_LIST,
    });
    return ServerAPI.getOutageList().done(function (data) {
      console.log("outage data", data);
      dispatcher.dispatch({
        type: ActionTypes.SET_OUTAGE_LIST,
        list: data.data,
      });
    });
  },

  createOutage: function (data) {
    return ServerAPI.createOutage(data);
  },
  updateOutage: function (data) {
    return ServerAPI.updateOutage(data);
  },
  deleteOutage: function (outageId) {
    return ServerAPI.deleteOutage(outageId);
  },

  getOverrideReasonCodeList: function () {
    $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "requestList/overrideReasonCodes",
      success: function (res) {
        dispatcher.dispatch({
          type: ActionTypes.OVERRIDE_REASON_CODES_LOADED,
          codes: res.data || [],
        });
      },
    });
  },

  /**
   * Loads the dispatcher desk territory list from the server
   */
  getTerritoryList: function (token) {
    $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "dispatcherDesk/list",
      dataType: "json",
      success: function (data) {
        if (data.success) {
          dispatcher.dispatch({
            type: ActionTypes.TERRITORY_LIST_LOADED,
            territories: data.data.deskList,
          });
        } else {
          var messages = [];
          for (var i = 0; i < data.errors.length; i++) {
            messages.push({
              field: "voidFailure",
              message: data.errors[i].message,
              type: "error",
            });
          }
          dispatcher.dispatch({
            type: ActionTypes.TERRITORY_LIST_FAILED_LOAD,
            message: messages,
          });
        }
      },
    });
  },

  /**
   * loads the the dispatcher desk territory details for the given desk id
   * @param deskId 'DSXXA' where XX is the desk number and A is the optional suffix
   */
  getTerritoryDetail: function (deskId) {
    setTimeout(function () {
      dispatcher.dispatch({
        type: ActionTypes.TERRITORY_DETAIL_LOADING,
      });
    }, 0);
    var desk = { deskId: deskId };
    $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "dispatcherDesk/details",
      dataType: "json",
      data: deskId,
      success: function (data) {
        if (data.success) {
          setTimeout(function () {
            dispatcher.dispatch({
              type: ActionTypes.TERRITORY_DETAILS_LOADED,
              details: data.data,
            });
          }, 0);
        } else {
          var messages = [];
          for (var i = 0; i < data.errors.length; i++) {
            messages.push({
              field: "voidFailure",
              message: data.errors[i].message + " loading territory details",
              type: "error",
            });
          }
          dispatcher.dispatch({
            type: ActionTypes.TERRITORY_DETAIL_FAILED_LOAD,
            message: messages,
          });
        }
      },
    });
  },

  /**
   * loads the list of subdivisions that are available for restrictions to be issued on
   */
  getSubdivisionList: function (token) {
    $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "subdivision/list",
      dataType: "json",
      success: function (data) {
        if (data.success) {
          dispatcher.dispatch({
            type: ActionTypes.SUBDIVISION_LIST_LOADED,
            subs: data.data.subdivisions,
          });
        } else {
          //handle data.errors...
        }
      },
    });
  },

  getDivisionList: function () {
    $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "subdivision/divisions",
      dataType: "json",
      success: function (data) {
        dispatcher.dispatch({
          type: ActionTypes.DIVISION_LIST_LOADED,
          divisions: data,
        });
      },
    });
  },

  getPtcSubdivisionList: function () {
    $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "subdivision/ptcList",
      dataType: "json",
      success: function (data) {
        if (data.success) {
          dispatcher.dispatch({
            type: ActionTypes.PTC_SUBDIVISION_LIST_LOADED,
            subs: data.data,
          });
        } else {
          //handle data.errors...
        }
      },
    });
  },

  getActiveList: function (params) {
    //settimeout is required so that an invariant violation is not thrown when calling this action
    //from a store in the middle of a dispatch
    // if (issuedListXhr && issuedListXhr.readyState != 4) {
    //     issuedListXhr.abort();
    //     console.log('cancelling previous call to issued list:', issuedListXhr);
    // }

    setTimeout(function () {
      dispatcher.dispatch({
        type: ActionTypes.ACTIVE_LIST_LOADING,
      });
    }, 0);

    setTimeout(function () {
      issuedListXhr = ServerAPI.getActiveList(params);

      issuedListXhr.done(function (data) {
        dispatcher.dispatch({
          type: ActionTypes.ACTIVE_LIST_LOADED,
          list: data,
        });
      });
      issuedListXhr.fail(function () {
        dispatcher.dispatch({
          type: ActionTypes.LIST_FAILED_LOADING,
          message: [
            {
              message: "Unable to load the list. Please refresh the page.",
              type: "error",
            },
          ],
        });
      });
    }, 10);
  },

  getActiveListForSub: function (sub) {
    //settimeout is required so that an invariant violation is not thrown when calling this action
    //from a store in the middle of a dispatch
    // if (issuedListXhr && issuedListXhr.readyState != 4) {
    //     issuedListXhr.abort();
    //     console.log('cancelling previous call to issued list:', issuedListXhr);
    // }

    setTimeout(function () {
      dispatcher.dispatch({
        type: ActionTypes.SUB_ACTIVE_LIST_LOADING,
      });
    }, 0);

    setTimeout(function () {
      issuedListXhr = ServerAPI.getActiveListForSub(sub);

      issuedListXhr.done(function (data) {
        dispatcher.dispatch({
          type: ActionTypes.SUB_ACTIVE_LIST_LOADED,
          sub: sub,
          list: data.data,
        });
      });
      issuedListXhr.fail(function () {
        dispatcher.dispatch({
          type: ActionTypes.LIST_FAILED_LOADING,
          message: [
            {
              message: "Unable to load the list. Please refresh the page.",
              type: "error",
            },
          ],
        });
      });
    }, 10);
  },

  getActiveListForSubAndFormType: function (sub, formType, subTabTypeVal) {
    setTimeout(function () {
      dispatcher.dispatch({
        type: ActionTypes.SUB_ACTIVE_LIST_LOADING,
      });
    }, 0);

    setTimeout(function () {
      issuedListXhr = ServerAPI.getActiveListForSubAndFormType(
        sub,
        formType,
        subTabTypeVal
      );

      issuedListXhr.done(function (data) {
        dispatcher.dispatch({
          type: ActionTypes.SUB_ACTIVE_LIST_LOADED,
          sub: sub,
          list: data.data,
        });
      });
      issuedListXhr.fail(function () {
        dispatcher.dispatch({
          type: ActionTypes.LIST_FAILED_LOADING,
          message: [
            {
              message: "Unable to load the list",
              type: "error",
            },
          ],
        });
      });
    }, 10);
  },

  getRecentListForSub: function (sub, token) {
    setTimeout(function () {
      dispatcher.dispatch({
        type: ActionTypes.SUB_RECENT_LIST_LOADING,
      });
    }, 0);

    setTimeout(function () {
      issuedListXhr = ServerAPI.getRecentListForSub(
        sub,
        Constants.recentHours,
        token
      );

      issuedListXhr.done(function (data) {
        dispatcher.dispatch({
          type: ActionTypes.SUB_RECENT_LIST_LOADED,
          list: data.data,
        });
      });
      issuedListXhr.fail(function () {
        dispatcher.dispatch({
          type: ActionTypes.LIST_FAILED_LOADING,
          message: [
            {
              message: "Unable to load the list",
              type: "error",
            },
          ],
        });
      });
    }, 10);
  },

  /**
   * Loads the subdivision details for the given subdivision
   * @param subdivision the subdivisions abbreviation
   * @param token
   */
  getSubdivisionDetails: function (subdivision) {
    if (subdivision != "showall") {
      // var subObj = { sub: subdivision };
      $.ajax({
        type: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
        },
        url: storeUtils.URL_ROOT + "subdivision/details",
        dataType: "json",
        data: subdivision,
        success: function (data) {
          if (data.success) {
            console.log(
              "Successfully retrieved subdivision details",
              JSON.stringify(data.data)
            );

            var schData = SchematicAPI.getSubDetails(subdivision, data.data);

            schData =
              formConversion.convertSubDetailsToSchematicFormat(schData);

            dispatcher.dispatch({
              type: ActionTypes.SUBDIVISION_DETAILS_LOADED,
              details: schData,
            });
          } else {
            console.log("Failed to retrieved subdivision details", data);

            let lookUpData = SchematicAPI.getSubDetails(subdivision, null);

            dispatcher.dispatch({
              type: ActionTypes.SUBDIVISION_DETAILS_LOADED,
              details: lookUpData,
            });
          }
        },
        error: function (data, status, xhr) {
          console.log(
            "Failed to retrieved subdivision details, using GRIT data",
            data,
            status,
            xhr
          );

          var subData = SchematicAPI.getSubDetails(subdivision, null);

          dispatcher.dispatch({
            type: ActionTypes.SUBDIVISION_DETAILS_LOADED,
            details: subData,
          });
        },
      });
    }
  },

  getFormCSubdivisionDetails: function (subdivision) {
    if (subdivision !== "showall") {
      var subObj = { sub: subdivision };
      $.ajax({
        type: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
        },
        url: storeUtils.URL_ROOT + "subdivision/details",
        dataType: "json",
        data: JSON.stringify(subObj),
        success: function (data) {
          console.log(
            "Successfully retrieved subdivision details",
            JSON.stringify(data)
          );

          var schData = SchematicAPI.getSubDetails(subdivision, data);

          schData = formConversion.convertSubDetailsToSchematicFormat(schData);

          dispatcher.dispatch({
            type: ActionTypes.FORM_C_SUBDIVISION_DETAILS_LOADED,
            details: schData,
          });
        },
        error: function (data, status, xhr) {
          console.log(
            "Failed to retrieved subdivision details, using GRIT data",
            data,
            status,
            xhr
          );

          var subData = SchematicAPI.getSubDetails(subdivision, null);

          dispatcher.dispatch({
            type: ActionTypes.FORM_C_SUBDIVISION_DETAILS_LOADED,
            details: subData,
          });
        },
      });
    }
  },

  getSubdivisionDetailsPromise: function (subdivision) {
    if (subdivision != "showall") {
      var subObj = { sub: subdivision };
      return $.ajax({
        type: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
        },
        url: storeUtils.URL_ROOT + "subdivision/details",
        dataType: "json",
        data: JSON.stringify(subObj),
      });
    }
  },

  getUserRole: function () {
   return $.ajax({
      type: "GET",
      contentType: "application/converters; charset=utf-8",
      url: storeUtils.URL_ROOT + "auth/getAuthorizations",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      success: function (data) {
        if (data.success) {
          dispatcher.dispatch({
            type: ActionTypes.SET_USER_ROLE,
            user: data.data,
          });
          return true
        } else {
          dispatcher.dispatch({
            type: ActionTypes.TSS_CONNECTION_FAILED,
            message: ["TSS connection failed"],
          });
          return false
        }
      },
      error: function (data) {
        console.log("error", data);
        return false
      },
    });
  },

  getRequestListForHistory: function (filterParams) {
    setTimeout(function () {
      dispatcher.dispatch({
        type: ActionTypes.HISTORY_LIST_LOADING,
      });
    }, 0);

    console.log("loading history list for params:", filterParams);
    setTimeout(function () {
      $.ajax({
        type: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
        },
        url: storeUtils.URL_ROOT + "requestList/getHistoryList",
        data: JSON.stringify(filterParams),
        dataType: "json",
        success: function (data) {
          dispatcher.dispatch({
            type: ActionTypes.HISTORY_LIST_LOADED,
            data: data.data,
          });
          console.log("history list loaded:", data);
        },
        error: function (data) {
          console.log("error", data);
          dispatcher.dispatch({
            type: ActionTypes.LIST_FAILED_LOADING,
            message: [
              {
                message: "Unable to load the list",
                type: "error",
              },
            ],
          });
        },
      });
    }, 10);
  },

  getRequestListForCompare: function (filterParams) {
    setTimeout(function () {
      dispatcher.dispatch({
        type: ActionTypes.HISTORY_LIST_LOADING,
      });
    }, 0);

    console.log("loading compare list for params:", filterParams);
    setTimeout(function () {
      $.ajax({
        type: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
        },
        url: storeUtils.URL_ROOT + "requestList/compareList",
        data: JSON.stringify(filterParams),
        dataType: "json",
        success: function (data) {
          dispatcher.dispatch({
            type: ActionTypes.HISTORY_LIST_LOADED,
            data: data,
          });
          console.log("compare list loaded:", data);
        },
        error: function (data) {
          console.log("error", data);
          dispatcher.dispatch({
            type: ActionTypes.LIST_FAILED_LOADING,
            message: [
              {
                message: "Unable to load the list",
                type: "error",
              },
            ],
          });
        },
      });
    }, 10);
  },

  viewRequestHistory: function (requestId) {
    window.open(
      storeUtils.URL_ROOT + "requestHistoryList?requestId=" + requestId,
      "_blank"
    );
  },

  openUsersAdminPage: function () {
    window.open(storeUtils.URL_ROOT + "gritUser", "_blank");
  },
  openPatternMaintenance: function () {
    window.open(storeUtils.URL_ROOT + "patternsMaintenance", "_blank");
  },

  openOutageAdminPage: function () {
    window.open(storeUtils.URL_ROOT + "outageList", "_blank");
  },

  openReasonCodeAdminPage: function () {
    window.open(storeUtils.URL_ROOT + "reasonCodes", "_blank");
  },

  openDefaultTrackAdminPage: function () {
    window.open(storeUtils.URL_ROOT + "defaultTracks", "_blank");
  },

  openHistoryPage: function (sub) {
    window.open(storeUtils.URL_ROOT + "historyPage?sub=" + sub, "_blank");
  },

  openOverridePage: function () {
    window.open(storeUtils.URL_ROOT + "override", "_blank");
  },

  openComparePage: function () {
    window.open(storeUtils.URL_ROOT + "compare", "_blank");
  },

  openAdminPages: function () {
    window.open(storeUtils.URL_ROOT + "gritUser", "_blank");
  },

  openSlsPage: function () {
    window.open(storeUtils.URL_ROOT + "gritItems", "_blank");
  },
  subRecalculate: function () {
    window.open(storeUtils.URL_ROOT + "subRecalculate", "_blank");
  },

  /**
   * Calls to the server and opens the form a and form b web browse print windows
   */
  openPrintWindows: function (sub) {
    var bWindow = window.open(
      "../PdfPrint/printNewFormBList?type=" +
      Constants.RestrictionTypes.B +
      "&status=" +
      STATUS.ISSUED +
      "&subdivision=" +
      sub,
      "formbprintwindow",
      "toolbar=no,width=1000,height=600,left=100,top=20,status=no,scrollbars=yes,resize=no"
    );

    function formBCheck() {
      if (bWindow.document.readyState === "complete") {
        // if loaded
        bWindow.document.title = sub + " Form B Restriction";
      } else {
        // if not loaded yet
        setTimeout(formBCheck, 10); // check in another 10ms
      }
    }

    formBCheck();

    var aWindow = window.open(
      "../PdfPrint/printNewFormAList?type=" +
      Constants.RestrictionTypes.A +
      "&status=" +
      STATUS.ISSUED +
      "&subdivision=" +
      sub,
      "formaprintwindow",
      "toolbar=no,width=1000,height=600,left=100,top=200,status=no,scrollbars=yes,resize=no"
    );

    function formACheck() {
      if (aWindow.document.readyState === "complete") {
        // if loaded
        aWindow.document.title = sub + " Form A Listing";
      } else {
        // if not loaded yet
        setTimeout(formACheck, 10); // check in another 10ms
      }
    }
    formACheck();
  },

  openBPrintWindow: function (sub) {
    var bWindow = window.open(
      "../PdfPrint/printNewFormBList?type=" +
      Constants.RestrictionTypes.B +
      "&status=" +
      STATUS.ISSUED +
      "&subdivision=" +
      sub,
      "formbprintwindow",
      "toolbar=no,width=1000,height=600,left=100,top=20,status=no,scrollbars=yes,resize=no"
    );

    function formBCheck() {
      if (bWindow.document.readyState === "complete") {
        // if loaded
        bWindow.document.title = sub + " Form B Restriction";
      } else {
        // if not loaded yet
        setTimeout(formBCheck, 10); // check in another 10ms
      }
    }

    formBCheck();
  },

  downloadFormAsPdf: (
    subdivision,
    formTypeParm,
    selectedStatus = STATUS.ISSUED
  ) => {
    const xml = new XMLSerializer();
    const svgTemplate = $("#mainSchematic svg").clone();
    document.body.append(svgTemplate[0]);
    svgTemplate.children().children().each(function () { $(this).removeAttr("transform") });
    const { height, width } = svgTemplate.children().get(0).getClientRects()[0];
    svgTemplate.attr("viewBox", `0 0 ${width + 20} ${height + 20}`);
    const svgCode = xml.serializeToString(svgTemplate[0]);
    document.body.removeChild(svgTemplate[0]);
    const body = JSON.stringify({
      formTypeParm,
      subTabTypeVal: "",
      subdivision,
      isDispacher: "",
      status: [selectedStatus],
      territory: "",
      schematicTitle: "",
      schematicSubTitle: "",
      printType: "",
      pageType: "",
      pageLayout: "",
      svgData: [],
      schema: svgCode
    });

    const req = fetch(storeUtils.URL_ROOT + "print/forms", {
      method: "POST",
      body,
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      }),
    });

    ServerActions.downloadPdfFile(req);
  },

  downloadShowField: () => {
    const req = fetch(storeUtils.URL_ROOT + "print/showFieldGuide", {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      }),
    });

    ServerActions.downloadPdfFile(req);
  },

  downloadPdfFile: (apiReq) => {
    apiReq
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }

        res.blob().then((blob) => {
          const url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          window.URL.revokeObjectURL(blob);
        });

      })
      .catch((e) => {
        console.log("failed download file", e);
        alert("Failed to download PDF file. Please try after sometime");
      });
  },

  openSchematicPrintWindow: function (division, sub, height, width, status) {
    //Get the form Bs we want to highlight
    var issuedParams = { status: [status] };
    issuedParams.type = Constants.RestrictionTypes.B;
    issuedParams.subdivision = sub;

    var restrictions = [];

    issuedListXhr = ServerAPI.getRestrictionPrintList(issuedParams);

    issuedListXhr.done(function (data) {
      //Convert the restrictions to the client format
      restrictions = data.map(function (form) {
        return formConversion.getClientFormat(form);
      });

      console.log("Success getting form Bs for Schematic Print", restrictions);

      //Highlight then print
    });
    issuedListXhr.fail(function () {
      console.log("Failed to get form Bs for Schematic Print");
    });
  },

  validateBorderingFlag: function (flag, row) {
    var data = { flag: flag, row: row };
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "subdivision/validateFlag",
      dataType: "json",
      data: JSON.stringify(data),
    });
  },
  calculateSubdivision: function (selectedSubdivision) {
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "trackCalculation/updatedSubdivisions",
      dataType: "json",
      data: JSON.stringify({ subdivisions: selectedSubdivision }),
      success: function (data) {
        if (data.success) {
          dispatcher.dispatch({
            type: ActionTypes.SUBDIVISION_RECALCULATE_SUCCESS,
            data: data,
          });
        } else {
          dispatcher.dispatch({
            type: ActionTypes.SUBDIVISION_RECALCULATE_FAILED,
            data: data,
          });
        }
      },
    });
  },
  //save user Initials
  saveUserInitials: function (initials) {
    var data = { initials };
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "auth/saveUserInitials",
      dataType: "json",
      data: JSON.stringify(data),
    });
  },

  getRequestHistory: (reqId) => ServerAPI.getRequestHistory(reqId),

  /**
   * Gets the list of existing restrictions or requests that fall within the given parameters
   * @param startDate
   * @param startTime
   * @param endDate
   * @param endTime
   * @param subdivision
   * @param type
   * @param status
   */
  getExistingRestricionsGuids: function () {
    //TODO: return a list of requests, or guids would be fine really....
  },

  //validateForm: function(form, newIndex, submitAction, validationOnly, clearForm, newForm){
  //	var controllerMethod = '';
  //	var data = {request: formConversion.getServerFormat(form)};
  //	switch(submitAction){
  //		case Constants.BatchTypes.ISSUE:
  //			controllerMethod = 'validateNewRestriction';
  //			break;
  //		case Constants.BatchTypes.APPROVE:
  //		case Constants.BatchTypes.MODIFY:
  //			controllerMethod = 'validateUpdatedRestriction';
  //			break;
  //		case Constants.BatchTypes.REJECT:
  //		case Constants.BatchTypes.VOID:
  //		default:
  //			break;
  //	}
  //	if(controllerMethod){
  //		$.ajax({
  //			type:"POST",
  //			contentType: "application/converters; charset=utf-8",
  //			url:storeUtils.URL_ROOT + 'validate/' + controllerMethod,
  //			data: JSON.stringify(data),
  //			success: function (data, status, xhr) {
  //				if(data.success){
  //					dispatcher.dispatch({
  //						type: ActionTypes.BATCH_VALIDATION_SUCCESSFUL,
  //						newIndex: newIndex,
  //						form: form,
  //						validationOnly: validationOnly,
  //						clearForm: clearForm,
  //						newForm: newForm,
  //						message: [{field:'formBform', message:"Validation successful", type: 'info'}]
  //					});
  //				}
  //				else{
  //					var messages = [];
  //					for(var i=0;i < data.errors.length; i++){
  //						messages.push({field:'formBform', message:data.errors[i].message, type: 'error'});
  //					}
  //					dispatcher.dispatch({
  //						type:ActionTypes.PERSIST_FAILED_FORM_B_RESTRICTION,
  //						message : messages
  //					});
  //				}
  //			},
  //			error:  function (data,status,error) {
  //				console.log("transport to the server failed on batch validate", data, status, error);
  //				dispatcher.dispatch({
  //					type:ActionTypes.PERSIST_FAILED_FORM_B_RESTRICTION,
  //					message : [{field:'formBform', message: 'A problem occurred validating this form', type: 'error'}]
  //				});
  //			},
  //			dataType: "json"
  //		});
  //	}
  //	else{
  //		dispatcher.dispatch({
  //			type: ActionTypes.BATCH_VALIDATION_SUCCESSFUL,
  //			newIndex: newIndex,
  //			form: form,
  //			validationOnly: validationOnly,
  //			clearForm: clearForm,
  //			newForm: newForm,
  //			message: [{field:'formBform', message:"Validation successful", type: 'info'}]
  //		});
  //	}
  //},

  //submitBatchForms: function(batchForms, submitAction, printLata, reasonList){
  //	var convertedBatch = [];
  //	for(var i = 0; i < batchForms.length; i++){
  //		convertedBatch[i] = formConversion.getServerFormat(batchForms[i]);
  //	}
  //
  //	var controllerMethod = '';
  //	var data;
  //	switch(submitAction){
  //		case Constants.BatchTypes.APPROVE:
  //		case Constants.BatchTypes.ISSUE:
  //			controllerMethod = 'batchIssue';
  //			data = {requests: convertedBatch, printLata: printLata};
  //			break;
  //		case Constants.BatchTypes.MODIFY:
  //			controllerMethod = 'batchUpdate';
  //			data = {requests: convertedBatch, printLata: printLata};
  //			break;
  //		case Constants.BatchTypes.REJECT:
  //			controllerMethod = 'batchReject';
  //
  //			var requestIds = [];
  //			for(var i = 0; i < convertedBatch.length; i++){
  //				requestIds.push({id: convertedBatch[i].id, reason: "Batch Reject"});
  //			}
  //
  //			data = {requests: convertedBatch, printLata: printLata};
  //			break;
  //		case Constants.BatchTypes.VOID:
  //			controllerMethod = 'batchPurge';
  //
  //			var requestIds = [];
  //			for(var i = 0; i < convertedBatch.length; i++){
  //				requestIds.push(convertedBatch[i].id);
  //			}
  //
  //			data = {requests: requestIds, printLata: printLata};
  //			break;
  //		default:
  //			break;
  //	}
  //
  //	$.ajax({
  //		type:"POST",
  //		contentType: "application/converters; charset=utf-8",
  //		url:storeUtils.URL_ROOT + 'batch/' + controllerMethod,
  //		data: JSON.stringify(data),
  //		success: function (data, status, xhr) {
  //			if(data.success){
  //				debugger;
  //				dispatcher.dispatch({
  //					type: ActionTypes.BATCH_SUBMIT_SUCCESSFUL,
  //					message: [{field:'formBform', message:"Batch submission has been successfully processed", type: 'info'}]
  //				});
  //			}
  //			else{
  //				var messages = [];
  //				for(var j = 0; j < data.data.length; j++){
  //					for(var i = 0; i < data.data.errors.length; i++){
  //						messages.push({field: 'submitFailure', message: (data.errors[i].message + ' on form ' + (j+1)).toString(), type: 'error'});
  //					}
  //				}
  //				dispatcher.dispatch({
  //					type:ActionTypes.PERSIST_FAILED_BATCH,
  //					message : messages
  //				});
  //			}
  //		},
  //		error:  function (data,status,error) {
  //			console.log("transport to the server failed on batch submit", data, status, error);
  //			dispatcher.dispatch({
  //				type:ActionTypes.PERSIST_FAILED_FORM_B_RESTRICTION,
  //				message : [{field:'formBform', message: 'A problem occurred saving this batch submit', type: 'error'}]
  //			});
  //		},
  //		dataType: "json"
  //	});
  //}
};
